/** @jsxImportSource @emotion/react */
import { Theme, useTheme, SelectProps, Select as SelectMaterial, MenuItem } from '@mui/material';
import React, { ReactNode } from 'react';
import { StylesClassName, UseStyles } from 'types/styles';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useIntl } from 'react-intl';

export interface ISelectProps extends Omit<SelectProps, 'placeholder' | 'className'> {
  className?: StylesClassName;
  children?: ReactNode;
  placeholder?: string | boolean;
}

const Select: React.FC<ISelectProps> = ({ className, children, placeholder, ...rest }) => {
  const theme = useTheme() as Theme;
  const classes = useStyles(theme);
  const { formatMessage } = useIntl();

  return (
    <SelectMaterial
      css={[classes.Select, className]}
      displayEmpty={!!placeholder}
      IconComponent={KeyboardArrowDownIcon}
      {...rest}
    >
      {placeholder && (
        <MenuItem disabled hidden value={''}>
          {typeof placeholder === 'boolean'
            ? formatMessage({ id: 'Select.select', defaultMessage: 'Select' }) + '...'
            : placeholder}
        </MenuItem>
      )}
      {children}
    </SelectMaterial>
  );
};

const useStyles = (theme: Theme): UseStyles => ({
  Select: {},
  placeholder: {},
});

export default Select;
